/* eslint-disable import/prefer-default-export */

const fieldStructure = {
  id: '',
  type: 'text',
  label: '',
  minLength: -1,
  maxLength: -1,
  pattern: '',
  errorText: '',
  isRequired: true,
  defaultValue:''
}

const emailAddressStructure = {
  ...fieldStructure,
  minLength: 7,
  maxLength: 66,
  pattern: /(((\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*),)*((\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*))),?/,
  errorText: 'Enter email. e.g. : matt@example.com',
  defaultValue:''
}

/**
 * Array of User Manager's user details fields.
 * Key and Id must be same. e.g. userId: should be same for id:'userId'
 * This should be the only single point of reference for schema
 */
export const umFieldsSchema = {
  userId: {
    ...fieldStructure,
    id: 'userId',
    label: 'User Id',
    minLength: 6,
    maxLength: 10,
    pattern: /^[a-zA-Z0-9_-]{6,10}$/,
    errorText: 'Enter 6-10 alpha numeric characters. (underscore and hyphen are allowed)',
    userExistError: 'User Id already exists.'
  },
  firstName: {
    ...fieldStructure,
    id: 'firstName',
    label: 'First Name',
    minLength: 2,
    maxLength: 25,
    pattern: /^[a-zA-Z0-9_-]{2,25}$/,
    errorText: 'Enter 2-25 alpha numeric characters. (underscore and hyphen are allowed)'
  },
  lastName: {
    ...fieldStructure,
    id: 'lastName',
    label: 'Last Name',
    minLength: 2,
    maxLength: 40,
    pattern: /^[a-zA-Z0-9]+(?:\s[a-zA-Z0-9]+)?$/,
    errorText: 'Enter 2-40 alpha numeric characters. (one space is allowed)'
  },
  emailAddress0: {
    ...emailAddressStructure,
    id: 'emailAddress0',
    label: 'Primary Email Address'
  },
  emailAddress1: {
    ...emailAddressStructure,
    id: 'emailAddress1',
    label: 'Additional Email Address'
  },
  emailAddress2: {
    ...emailAddressStructure,
    id: 'emailAddress2',
    label: 'Additional Email Address'
  },
  status: {
    ...fieldStructure,
    id: 'status',
    label: 'Status',
    minLength: 1,
    maxLength: 1,
    errorText: 'Please select a value.',
    defaultValue:'A'
  },
  // contactId: {
  //   ...fieldStructure,
  //   id: 'contactId',
  //   label: 'Contact Id',
  //   minLength: 0,
  //   maxLength: 12,
  //   pattern: '',
  //   errorText: '',
  //   isRequired: false
  // },
  qid: {
    ...fieldStructure,
    id: 'qid',
    label: 'QID',
    minLength: 4,
    maxLength: 4,
    errorText: '',
    isRequired: false,
    isReadOnly: true
  },
  credential: {
    ...fieldStructure,
    id: 'credential',
    type: 'password',
    label: 'Password',
    minLength: 8,
    maxLength: 20,
    pattern: '',
    errorText: 'Password must be 8-20 characters, not include your User ID or the word "password", and must have at least 1 numeric, 1 lower case, 1 upper case, and 1 special character.'
  },
  confirmCredential: {
    ...fieldStructure,
    id: 'confirmCredential',
    type: 'password',
    label: 'Confirm Password',
    minLength: 1,
    maxLength: 100,
    pattern: '',
    errorText: 'Enter confirm password',
    pwdMismatchErrorText: 'Password and confirm password do not match'
  },
  // createdBy: {
  //   ...fieldStructure,
  //   id: 'createdBy',
  //   label: 'Created By',
  //   type: 'label',
  //   isRequired: false
  // },
  // createdDateTime: {
  //   ...fieldStructure,
  //   id: 'createdDateTime',
  //   label: 'Created DateTime',
  //   type: 'label',
  //   isRequired: false
  // },
  // lastUpdatedBy: {
  //   ...fieldStructure,
  //   id: 'lastUpdatedBy',
  //   label: 'Last Updated By',
  //   type: 'label',
  //   isRequired: false
  // },
  lastUpdateDateTime: {
    ...fieldStructure,
    id: 'lastUpdateDateTime',
    label: 'Last Updated DateTime',
    type: 'label',
    isRequired: false
  }
}

const fieldStateStructure = {
  id: '',
  value: '',
  isError: false,
  isFocused: false,
  isUserExistsError: false,
  isCompanyExistsError: false,
  isAlternateIdExistsError: false
}

/**
 * initial state  of User Manager's user details fields.
 * Key and Id must be same. e.g. userId: should be same for id:'userId'
 * This should be the only single point of reference for fields state management.
 * FieldsState keys must match to the FieldsSchema
 */
export const umFieldsState = {
  userId: {
    ...fieldStateStructure,
    id: 'userId'
  },
  firstName: {
    ...fieldStateStructure,
    id: 'firstName'
  },
  lastName: {
    ...fieldStateStructure,
    id: 'lastName'
  },
  emailAddress0: {
    ...fieldStateStructure,
    id: 'emailAddress0'
  },
  emailAddress1: {
    ...fieldStateStructure,
    id: 'emailAddress1'
  },
  emailAddress2: {
    ...fieldStateStructure,
    id: 'emailAddress2'
  },
  status: {
    ...fieldStateStructure,
    id: 'status',
    value: 'A'
  },
  // contactId: {
  //   ...fieldStateStructure,
  //   id: 'contactId'
  // },
  qid: {
    ...fieldStateStructure,
    id: 'qid'
  },
  credential: {
    ...fieldStateStructure,
    id: 'credential'
  },
  confirmCredential: {
    ...fieldStateStructure,
    id: 'confirmCredential',
    isPasswordMismatch: false
  },
  // createdBy: {
  //   ...fieldStateStructure,
  //   id: 'createdBy'
  // },
  // createdDateTime: {
  //   ...fieldStateStructure,
  //   id: 'createdDateTime'
  // },
  // lastUpdatedBy: {
  //   ...fieldStateStructure,
  //   id: 'lastUpdatedBy'
  // },
  lastUpdateDateTime: {
    ...fieldStateStructure,
    id: 'lastUpdateDateTime'
  }
}

export const loginFieldsSchema = {
  companyId: {
    ...fieldStructure,
    id: 'companyId',
    label: 'Company Id',
    minLength: 1,
    maxLength: 50,
    errorText: 'Company Id is required.'
  },
  userId: {
    ...fieldStructure,
    id: 'userId',
    label: 'User Id',
    minLength: 1,
    maxLength: 50,
    errorText: 'User Id is required'
  },
  qid: {
    ...fieldStructure,
    id: 'qid',
    type: 'password',
    label: 'QID',
    minLength: 4,
    maxLength: 4,
    errorText: 'QID is required'
  },
  credential: {
    ...fieldStructure,
    id: 'credential',
    type: 'password',
    label: 'Password',
    minLength: 1,
    maxLength: 100,
    errorText: 'Password is required'
  },
  confirmCredential: {
    ...fieldStructure,
    id: 'confirmCredential',
    type: 'password',
    label: 'Confirm Password',
    minLength: 1,
    maxLength: 100,
    errorText: 'Confirm Password is required',
    pwdMismatchErrorText: 'Password and confirm password do not match'
  }
}

export const loginFieldsState = {
  companyId: {
    ...fieldStateStructure,
    id: 'companyId',
    validationType: 'login;save'
    // value: 'EL0018'
  },
  userId: {
    ...fieldStateStructure,
    id: 'userId',
    validationType: 'login;save'
    // value: 'mandadicad'
  },
  qid: {
    ...fieldStateStructure,
    id: 'qid',
    validationType: 'save'
    // value: 'mandadicad'
  },
  credential: {
    ...fieldStateStructure,
    id: 'credential',
    validationType: 'login;save'
    // value: 'connect20'
  },
  confirmCredential: {
    ...fieldStateStructure,
    id: 'confirmCredential',
    validationType: 'save'
    // value: 'connect20'
  }
}

export const upFieldsSchema = {
  userId: {
    ...fieldStructure,
    id: 'userId',
    label: 'User Id',
    minLength: 6,
    maxLength: 10,
    pattern: /^[a-zA-Z0-9_-]{6,10}$/,
    errorText: 'Enter 6-10 alpha numeric characters. (underscore and hyphen are allowed)',
    userExistError: 'User Id already exists.'
  },
  firstName: {
    ...fieldStructure,
    id: 'firstName',
    label: 'First Name',
    minLength: 2,
    maxLength: 25,
    pattern: /^[a-zA-Z0-9_-]{2,25}$/,
    errorText: 'Enter 2-25 alpha numeric characters. (underscore and hyphen are allowed)'
  },
  lastName: {
    ...fieldStructure,
    id: 'lastName',
    label: 'Last Name',
    minLength: 2,
    maxLength: 40,
    pattern: /^[a-zA-Z0-9]+(?:\s[a-zA-Z0-9]+)?$/,
    errorText: 'Enter 2-40 alpha numeric characters. (one space is allowed)'
  },
  emailAddress0: {
    ...emailAddressStructure,
    id: 'emailAddress0',
    label: 'Primary Email Address'
  },
  emailAddress1: {
    ...emailAddressStructure,
    id: 'emailAddress1',
    label: 'Additional Email Address'
  },
  emailAddress2: {
    ...emailAddressStructure,
    id: 'emailAddress2',
    label: 'Additional Email Address'
  },
  qid: {
    ...fieldStructure,
    id: 'qid',
    label: 'QID',
    minLength: 4,
    maxLength: 4,
    pattern: /^[0-9]{4,4}$/,
    errorText: 'Enter 4 numeric characters.',
    isRequired: true,
    isReadOnly: false

  },
  currentCredential: {
    ...fieldStructure,
    id: 'currentCredential',
    type: 'password',
    label: 'Current Password',
    minLength: 1,
    maxLength: 100,
    pattern: '',
    errorText: 'Enter current password.'
  },
  credential: {
    ...fieldStructure,
    id: 'credential',
    type: 'password',
    label: 'Password',
    minLength: 8,
    maxLength: 20,
    pattern: '',
    errorText: 'Password must be 8-20 characters, not include your User ID or the word "password", and must have at least 1 numeric, 1 lower case, 1 upper case, and 1 special character.'
  },
  confirmCredential: {
    ...fieldStructure,
    id: 'confirmCredential',
    type: 'password',
    label: 'Confirm Password',
    minLength: 1,
    maxLength: 100,
    pattern: '',
    errorText: 'Enter confirm password',
    pwdMismatchErrorText: 'Password and confirm password do not match.'
  }
}

export const upFieldsState = {
  userId: {
    ...fieldStateStructure,
    id: 'userId'
  },
  firstName: {
    ...fieldStateStructure,
    id: 'firstName'
  },
  lastName: {
    ...fieldStateStructure,
    id: 'lastName'
  },
  emailAddress0: {
    ...fieldStateStructure,
    id: 'emailAddress0'
  },
  emailAddress1: {
    ...fieldStateStructure,
    id: 'emailAddress1'
  },
  emailAddress2: {
    ...fieldStateStructure,
    id: 'emailAddress2'
  },
  qid: {
    ...fieldStateStructure,
    id: 'qid'
  },
  currentCredential: {
    ...fieldStateStructure,
    id: 'currentCredential'
  },
  credential: {
    ...fieldStateStructure,
    id: 'credential'
  },
  confirmCredential: {
    ...fieldStateStructure,
    id: 'confirmCredential',
    isPasswordMismatch: false
  }
}

export const companyFieldsSchema = {
  companyId: {
    ...fieldStructure,
    id: 'companyId',
    label: 'Company Id'
  },
  companyName: {
    ...fieldStructure,
    id: 'companyName',
    label: 'Company Name',
    minLength: 3,
    maxLength: 50,
    pattern: /^[a-zA-Z0-9\s_-]{3,50}$/,
    errorText: 'Enter 3-50 alpha numeric characters. (space, underscore and hyphen are allowed)',
    companyExistError: 'Company Name already exists.'
  },
  applicationId: {
    ...fieldStructure,
    id: 'applicationId',
    label: 'Application Type',
    errorText: 'Please select a value.'
  },
  alternateId: {
    ...fieldStructure,
    id: 'alternateId',
    label: 'Alternate Id',
    minLength: 3,
    maxLength: 4,
    pattern: /^[0-9]{3,4}$/,
    errorText: 'Enter 3-4 numeric characters.',
    alternateIdExistError: 'alternateId already exists.'
  },
  status: {
    ...fieldStructure,
    id: 'status',
    label: 'Status',
    minLength: 1,
    maxLength: 1,
    errorText: 'Please select a value.'
  },
  createDateTime: {
    ...fieldStructure,
    id: 'createDateTime',
    label: 'Create Date',
    isRequired: false
  },
  lastUpdateDateTime: {
    ...fieldStructure,
    id: 'lastUpdateDateTime',
    label: 'Modified Date',
    isRequired: false
  },
  liveDate: {
    ...fieldStructure,
    id: 'liveDate',
    label: 'Activated Date',
    isRequired: false
  },
  deactivationDate: {
    ...fieldStructure,
    id: 'deactivationDate',
    label: 'Deactivated Date',
    isRequired: false
  },
  notes: {
    ...fieldStateStructure,
    id: 'notes',
    label: 'Notes'
  }
}

export const companyFieldsState = {
  companyId: {
    ...fieldStateStructure,
    id: 'companyId'
  },
  companyName: {
    ...fieldStateStructure,
    id: 'companyName'
  },
  applicationId: {
    ...fieldStateStructure,
    id: 'applicationId'
  },
  alternateId: {
    ...fieldStateStructure,
    id: 'alternateId'
  },
  status: {
    ...fieldStateStructure,
    id: 'status',
    value: 'A'
  },
  createDateTime: {
    ...fieldStateStructure,
    id: 'createDateTime'
  },
  lastUpdateDateTime: {
    ...fieldStateStructure,
    id: 'lastUpdateDateTime'
  },
  liveDate: {
    ...fieldStateStructure,
    id: 'liveDate'
  },
  deactivationDate: {
    ...fieldStateStructure,
    id: 'deactivationDate'
  },
  notes: {
    ...fieldStateStructure,
    id: 'notes'
  }
}
